"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = require("../../../utils/analytics");
function setupAnalytics(storeData) {
    (function setupFPTI(win, doc) {
        // eslint-disable-line
        var DEPTH_LIMIT = 5;
        if (!win.fpti) {
            win.fpti = {};
        }
        function getPageName(url) {
            if (url === void 0) { url = win.location.pathname; }
            return analytics_1.default.getPageNameFromUrl(url);
        }
        win.fpti = storeData && storeData.sys.tracking.fpti;
        var fptiName = getPageName() || win.fpti.name, fptiDataString = win.fpti["dataString"], // eslint-disable-line
        fptiServerURL = win.fpti["serverURL"]; // eslint-disable-line
        win.PAYPAL = win.PAYPAL || {};
        if (typeof win.PAYPAL.analytics !== "undefined") {
            win.PAYPAL.core = win.PAYPAL.core || {};
            win.PAYPAL.core[fptiName] = win.PAYPAL.analytics.setup({
                data: fptiDataString,
                url: fptiServerURL,
            });
        }
        function setFPTIInstance() {
            win.PAYPAL.instance = new PAYPAL.analytics.Analytics();
            win.PAYPAL.instance.options.request.url = fptiServerURL;
        }
        // Alternative to pointer-events in CSS.
        // Drills up to 5 levels to check for 'A' or 'BUTTON' tags
        function getLinkName(elementNode, currentDepthCount) {
            if (currentDepthCount === void 0) { currentDepthCount = 0; }
            if (currentDepthCount > DEPTH_LIMIT || !elementNode) {
                return "";
            }
            if (elementNode.tagName.toUpperCase() === "A" ||
                elementNode.tagName.toUpperCase() === "BUTTON") {
                return (elementNode.name ||
                    elementNode.getAttribute("data-name") ||
                    "");
            }
            currentDepthCount = currentDepthCount + 1;
            return getLinkName(elementNode.parentElement, currentDepthCount);
        }
        function getFltkToken() {
            if (!win.PAYPAL.instance) {
                setFPTIInstance();
            }
            var referrer = win.document.referrer, identifier = referrer.includes("?token=")
                ? "token"
                : referrer.includes("&flowId=")
                    ? "flowId"
                    : null, fltk = null;
            var flowIdKeyLen = 8, tokenIdKeyLen = 7;
            switch (identifier) {
                case "flowId":
                    var flowIndex = referrer.indexOf("&flowId=");
                    fltk = referrer.substring(flowIndex + flowIdKeyLen, referrer.length);
                    break;
                case "token":
                    var tokenIndex = referrer.indexOf("?token="), andIndex = tokenIndex +
                        referrer.substring(tokenIndex).indexOf("&");
                    fltk = referrer.substring(tokenIndex + tokenIdKeyLen, andIndex);
                    break;
            }
            return fltk;
        }
        function triggerFPTIClick(linkName) {
            if (!win.PAYPAL.instance) {
                setFPTIInstance();
            }
            win.fpti.link = linkName;
            win.fpti.pglk = win.fpti.pgrp + "|" + linkName;
            win.fpti.pgln = win.fpti.page + "|" + linkName;
            win.fpti.operation_type = null;
            win.fpti.status = null;
            win.fpti.error_description = null;
            var fltkToken = getFltkToken();
            if (fltkToken) {
                win.fpti.fltk = fltkToken;
            }
            if (win.PAYPAL.instance) {
                win.PAYPAL.instance.recordClick();
            }
        }
        /**
         * triggers FPIT tracking on success or failure of operation
         */
        function triggerOperationResult(operation_type, status, errorDescription) {
            win.fpti.operation_type = operation_type;
            win.fpti.status = status;
            win.fpti.error_description = errorDescription;
            if (win.PAYPAL.instance) {
                win.PAYPAL.instance.recordImpression();
            }
        }
        function triggerFPTIImpression() {
            var pageGroup = "main:" + win.fpti.comp + ":" + getPageName(), pageName = "main:" + win.fpti.comp + ":" + getPageName() + ":::", locale = "";
            if (storeData && storeData.locality.country) {
                locale = storeData.locality.country;
            }
            if (win.fpti.link) {
                win.fpti.rlink = win.fpti.link;
            }
            if (win.fpti.pglk) {
                win.fpti.rpage = win.fpti.page;
            }
            win.fpti.pgrp = pageGroup;
            win.fpti.page = pageName;
            win.fpti.link = null;
            win.fpti.pglk = null;
            win.fpti.pgln = null;
            win.fpti.ccpg = locale;
            win.fpti.device_type = analytics_1.default.getDeviceInfo(storeData);
            win.fpti.operation_type = null;
            win.fpti.status = null;
            win.fpti.error_description = null;
            var fltkToken = getFltkToken();
            if (fltkToken) {
                win.fpti.fltk = fltkToken;
            }
            if (!win.PAYPAL.instance) {
                setFPTIInstance();
            }
            if (win.PAYPAL.instance) {
                win.PAYPAL.instance.recordImpression();
            }
        }
        function clickListener(e) {
            // TODO: Remove defaults after names are integrated across the app
            var listOfSupportedTags = {
                A: true,
                BUTTON: true,
                // For radio buttons
                LABEL: function (event) {
                    return event.target.getAttribute("for");
                },
            }, parentTrackingNode = analytics_1.default.getParentTrackingNode(e.target), isSupportedForTracking = !!parentTrackingNode
                ? listOfSupportedTags[parentTrackingNode.tagName.toUpperCase()]
                : false;
            if (isSupportedForTracking &&
                (isSupportedForTracking === true || isSupportedForTracking(e))) {
                var opsel = parentTrackingNode.getAttribute("data-track") &&
                    JSON.parse(JSON.stringify(parentTrackingNode.getAttribute("data-track")));
                if (opsel) {
                    win.fpti["opsel"] = opsel;
                }
                triggerFPTIClick(analytics_1.default.getNodeTrackingLinkName(parentTrackingNode));
            }
        }
        win.addEventListener("click", clickListener, false);
        win.PAYPAL.fpti = {
            triggerFPTIClick: triggerFPTIClick,
            triggerFPTIImpression: triggerFPTIImpression,
            triggerOperationResult: triggerOperationResult,
        };
        return win.PAYPAL.fpti;
    })(window, document);
}
exports.default = setupAnalytics;
